import React 			from 'react';
import BLComponent		from '../core/_BLComponent.jsx'
import blAjax			from '../utils/_ajax.jsx'

import {CustomAlert, onEscapePress}	from '../common/_Utilities.jsx';


export default class RegisterConfirmModal extends BLComponent
{
	constructor( props )
	{
		super( props );

		if ( !this.isRestoredFromContext() )
		{
			var	me			= blapp.session.getMe();
			var	curEmail	= me == null ? "" : me.skEmailAddr;

			this.state = 
				{
					wrongEmail: 	false
				,	updatedEmail: 	false
				,	resendEmail: 	false
				,	currentEmail:	curEmail
				, 	newEmail: 		''
				,	isProcessing:	false
				};
		}

		this._inboxMap	=
			{
				"gmail.com":	"https://mail.google.com"
			,	"hotmail.com":	"https://hotmail.com"
			,	"yahoo.com":	"https://mail.yahoo.com"
			,	"aol.com":		"https://mail.aol.com"
			};

	}

	componentDidMount()
	{
		blapp.session.onSessionUpdate( this.onSessionUpdate );
		onEscapePress(() => blapp.refs.get( "header" ).toggleMenu('confirm_email'));
	}

	componentWillUnmount() 
	{ 
		super.componentWillUnmount(); 
		blapp.session.offSessionUpdate( this.onSessionUpdate );
	}		

	componentDidUpdate() {
		onEscapePress(() => blapp.refs.get( "header" ).toggleMenu('confirm_email'));
	}

	render() 
	{
		var	splits		= this.state.currentEmail.split( '@' );
		var	inboxUrl	= null;
		var	style		= {};

		if ( splits.length == 2 )
			inboxUrl	= this._inboxMap[ splits[ 1 ] ];

		return (
			<div className="modal">
				<div className="modal__overlay"></div>
				<div className="modal__content modal__content--login-register">
					<div className="modal__header bg-color--cloud">
						<h1 className="modal__title">{$T("CONFIRM_EMAIL")}</h1>
						<i className="far fa-times modal__close" onClick={() => blapp.refs.get( "header" ).toggleMenu('confirm_email')}></i>
					</div>
					<div className="modal__body">
						<h2 className="small-title l-margin-bottom">{this.state.updatedEmail ? $T("UPDATE_SUCCESS") : $T("YOUVE_GOT")}</h2>
						<div className="l-margin-bottom" dangerouslySetInnerHTML={{__html: $T("EMAIL_DESC", [ this.state.currentEmail ])}}/>
						<div className="l-flex l-center">
							{ 
								inboxUrl ? 
									<div className="l-full-width l-margin-right--sm">
										<a href={inboxUrl} target="_blank" className="btn btn--cta l-full-width l-block">{$T("GO_TO_INBOX")}</a>
									</div>
									:
									null
							}
							<div className="l-full-width l-margin-left--sm">
								{this.state.resendEmail ?
									<div className="text-color--primaryGreen text--center"><i className="fas fa-check l-margin-right--md"></i>{$T("SEND_SUCCESS")}</div>
								:
									<button className="btn btn--grey l-full-width" onClick={() => this.doResend()} disabled={this.state.isProcessing}>{$T("RESEND")}</button>
								}
							</div>
						</div>
					</div>
					<div className="modal__footer">
						<small>{$T("WRONG_EMAIL")} <button className="btn btn--link" onClick={() => this.setState({wrongEmail: !this.state.wrongEmail})}>{this.state.wrongEmail ? $T("CANCEL") : $T("SEND_TO_NEW")}</button></small>
						{this.state.wrongEmail ? 
							<div className="input-button-set l-margin-top">
								<input type="text" className="text-input input-button-set__input" placeholder={$T("EMAIL_PLACEHOLDER")} value={this.state.newEmail} onChange={(e) => this.setState({newEmail: e.target.value})}/>
								<button className="btn btn--grey input-button-set__btn" onClick={() => this.doUpdate()} disabled={this.state.isProcessing}>{$T("UPDATE")}</button>
							</div>
						: null}
					</div>
				</div>
			</div>
		);
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	doResend()
	{
		this.setState( { isProcessing: true } );

		blAjax.call(
			"/resend_confirmation_email.ajax"
		,	{ urlReturn: window.location.href }
		).then(
			( data ) =>
			{
				if ( data.result == "EC_OK" )
				{
					if ( data.session )
						blapp.session.set( data.session, true );
					this.setState( { resendEmail: true, isProcessing: false } );
				}
				else
				{
					this.triggerAlert( $T( "ERR_EMAIL_FAILURE" ) );
					this.setState( { isProcessing: false } );
				}

			}
		).catch(
			( err ) =>
			{
				this.triggerAlert( $T( "ERR_EMAIL_FAILURE" ) );
				this.setState( { isProcessing: false } );
			}
		);
	}

	doUpdate()
	{
		this.setState( { isProcessing: true } );

		blAjax.call(
			"/resend_confirmation_email.ajax"
		,	{
				strNewEmailAddr:	this.state.newEmail
			,	urlReturn: 			window.location.href 
			}
		).then(
			( data ) =>
			{
				if ( data.result == "EC_OK" )
				{
					if ( data.session )
						blapp.session.set( data.session, true );
					this.setState( { updatedEmail: true, wrongEmail: false, resendEmail: false, isProcessing: false } );
				}
				else
				{
					this.triggerAlert( $T( "ERR_EMAIL_FAILURE" ) );
					this.setState( { isProcessing: false } );
				}

			}
		).catch(
			( err ) =>
			{
				switch ( err )
				{
				case "EC_INVALID_ACCESS":
					this.triggerAlert( $T( "ERR_INVALID_ACCESS" ) );
					break;
				case "EC_INVALID_PARAM":
					this.triggerAlert( $T( "ERR_INVALID_PARAM" ) );
					break;					
				case "EC_SIGNUP_INVALID_EMAIL":
					this.triggerAlert( $T( "ERR_INVALID_EMAIL" ) );
					break;
				case "EC_SIGNUP_EMAIL_EXISTS":
					this.triggerAlert( $T( "ERR_EMAIL_EXISTS" ) );
					break;
				default:
					this.triggerAlert( $T( "ERR_SYSTEM_ERROR", [ err ] ) );
					break;
				}
				
				this.setState( { isProcessing: false } );
			}
		);		
		
	}

	onSessionUpdate = () =>
	{
		var	me			= blapp.session.getMe();

		if ( me != null )
			this.setState( { currentEmail: me.skEmailAddr } );
	}

}

var $T	= BLComponent.createTextMap( 
	{
		"CONFIRM_EMAIL":
			{
				"en": "Confirm email"
			,	"kr": "이메일 확인"
			,	"es": "Confirmar dirección de correo"
			}
	,	"GO_TO_INBOX":
			{
				"en": "Go to inbox"
			,	"kr": "이메일 보러 가기"
			,	"es": "Ir a recibidos"
			}
	,	"RESEND":
			{
				"en": "Resend email"
			,	"kr": "이메일 다시 받기"
			,	"es": "Reenviar correo"
			}
	,	"YOUVE_GOT":
			{
				"en": "You've got mail!"
			,	"kr": "이메일을 확인 하세요!"
			,	"es": "¡Tienes un correo!"
			}
	,	"UPDATE_SUCCESS":
			{
				"en": "Email successfully updated!"
			,	"kr": "이메일 정보가 성공적으로 변경 되었습니다."
			,	"es": "¡Dirección actualizada correctamente!"
			}
	,	"EMAIL_DESC":
			{
				"en": "We sent an email to <strong>{{$0}}</strong>. Follow the link in the email to finish registration."
			,	"kr": "<strong>{{$0}}</strong> 으로 확인 이메일을 보냈습니다. 가입 완료를 위해 이메일 링크를 클릭해 주세요."
			,	"es": "Hemos enviado un correo a <strong>{{$0}}</strong>. Sigue el enlace en el correo para finalizar el registro."
			}
	,	"WRONG_EMAIL":
			{
				"en": "Wrong email address?"
			,	"kr": "잘못된 이메일 주소인가요?"
			,	"es": "¿Dirección incorrecta?"
			}
	,	"SEND_TO_NEW":
			{
				"en": "Send to new address"
			,	"kr": "이메일 주소 변경"
			,	"es": "Enviar a la dirección nueva"
			}
	,	"CANCEL":
			{
				"en": "Cancel"
			,	"kr": "취소"
			,	"es": "Cancelar"
			}
	,	"UPDATE":
			{
				"en": "Update"
			,	"kr": "변경"
			,	"es": "Actualizar"
			}
	,	"EMAIL_PLACEHOLDER":
			{
				"en": "New email address"
			,	"kr": "새 이메일 주소"
			,	"es": "Nueva dirección de correo"
			}
	,	"SEND_SUCCESS":
			{
				"en": "Email sent"
			,	"kr": "이메일 발송 완료"
			,	"es": "Correo enviado"
			}
	,	"ERR_EMAIL_FAILURE":
			{
				"en":	"Failed to send confirmation email."
			,	"kr":	"확인 메일 발송에 실패하였습니다."
			,	"es": 	"Error enviando correo de confirmación."
			}
	,	"ERR_INVALID_ACCESS":
			{
				"en":	"Invalid Access!"
			,	"kr":	"잘못된 접근입니다."
			,	"es": 	"¡Acceso no permitido!"
			}
	,	"ERR_INVALID_PARAM":
			{
				"en":	"Input value is invalid."
			,	"kr":	"입력값이 유효하지 않습니다."
			,	"es": 	"El valor introducido es inválido."
			}			
	,	"ERR_INVALID_EMAIL":
			{
				"en": "Email address is invalid."
			,	"kr": "유효하지 않은 이메일 주소입니다."
			,	"es": "La dirección de correo es inválida."
			}
	,	"ERR_EMAIL_EXISTS":
			{
				"en": "This email is already in use."
			,	"kr": "이미 사용중인 이메일 주소입니다."
			,	"es": "La dirección de correo ya está en uso."
			}
	,	"ERR_SYSTEM_ERROR":
			{
				"en": "System Error : {{$0}}"
			,	"kr": "시스템 에러 : {{$0}}"
			,	"es": "Error interno: {{$0}}"
			}
	}
);
